module.exports = __webpack_public_path__ + "static/media/icons-tech-accessories.8595a08f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/icons-tech-accessories.svg
// module id = 788
// module chunks = 0